/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface ImportResults
 */
export interface ImportResults {
  /**
   * number of rows failed to acquire a lock
   * @type {number}
   * @memberof ImportResults
   */
  collisions?: number;
  /**
   * number of new leads created
   * @type {number}
   * @memberof ImportResults
   */
  created?: number;
  /**
   * number of duplicate rows skipped
   * @type {number}
   * @memberof ImportResults
   */
  duplicates?: number;
  /**
   * number of batch exceptions
   * @type {number}
   * @memberof ImportResults
   */
  failedBatches?: number;
  /**
   * number of invalid rows skipped
   * @type {number}
   * @memberof ImportResults
   */
  skipped?: number;
  /**
   * total leads associated with list at import-time
   * @type {number}
   * @memberof ImportResults
   */
  total?: number;
  /**
   * number of existing leads updated
   * @type {number}
   * @memberof ImportResults
   */
  updated?: number;
}

/**
 * Check if a given object implements the ImportResults interface.
 */
export function instanceOfImportResults(value: object): value is ImportResults {
  return true;
}

export function ImportResultsFromJSON(json: any): ImportResults {
  return ImportResultsFromJSONTyped(json, false);
}

export function ImportResultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ImportResults {
  if (json == null) {
    return json;
  }
  return {
    collisions: json['collisions'] == null ? undefined : json['collisions'],
    created: json['created'] == null ? undefined : json['created'],
    duplicates: json['duplicates'] == null ? undefined : json['duplicates'],
    failedBatches:
      json['failed_batches'] == null ? undefined : json['failed_batches'],
    skipped: json['skipped'] == null ? undefined : json['skipped'],
    total: json['total'] == null ? undefined : json['total'],
    updated: json['updated'] == null ? undefined : json['updated'],
  };
}

export function ImportResultsToJSON(value?: ImportResults | null): any {
  if (value == null) {
    return value;
  }
  return {
    collisions: value['collisions'],
    created: value['created'],
    duplicates: value['duplicates'],
    failed_batches: value['failedBatches'],
    skipped: value['skipped'],
    total: value['total'],
    updated: value['updated'],
  };
}
